import { Nullable } from 'frontcore/presentation/types'

export const formattedDate = (date: Nullable<Date>) => {
  return date ? date.toLocaleDateString(): null
}
